/* global axios */
import ApiClient from './ApiClient';

class VoiceAiConfigAPI extends ApiClient {
  constructor() {
    super('voice_ai_config', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.patch(this.url, { voice_ai_config: data });
  }

  formOptions() {
    return axios.get(`${this.url}/form_options`);
  }

  uploadSkills(file, mode) {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('mode', mode || 'replace');
    return axios.post(`${this.url}/upload_skills`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  skillsStatus() {
    return axios.get(`${this.url}/skills_status`);
  }
}

export default new VoiceAiConfigAPI();
